import { render } from "./TohView.vue?vue&type=template&id=9498d06a"
import script from "./TohView.vue?vue&type=script&lang=js"
export * from "./TohView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__